import PropTypes from "prop-types";

import { WrapperContainer } from "../index";
import flexContainers from "../Containers/FlexContainers";
import { AccordionOption } from "./AccordionOption";

const Accordion = ({
  options,
  onSelectMainOption,
  onSelectSubOption,
  withCheckboxes = false,
  openedOptionId,
  onOpeningMainOption
}) => {
  return (
    <WrapperContainer Container={flexContainers.FlexColumnStart} gap={16} width="100%">
      {options.map((option) => (
        <AccordionOption
          key={option.mainOption.id}
          option={option}
          withCheckboxes={withCheckboxes}
          isOpen={openedOptionId === option.mainOption.id}
          onOpeningMainOption={onOpeningMainOption}
          onSelectMainOption={onSelectMainOption}
          onSelectSubOption={onSelectSubOption}
        />
      ))}
    </WrapperContainer>
  );
};

Accordion.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      mainOption: PropTypes.shape({
        id: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired,
        selected: PropTypes.bool.isRequired,
        partiallySelected: PropTypes.bool.isRequired
      }),
      subOptions: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string.isRequired,
          value: PropTypes.string.isRequired,
          selected: PropTypes.bool.isRequired
        })
      )
    })
  ).isRequired,
  onSelectMainOption: PropTypes.func,
  onSelectSubOption: PropTypes.func,
  withCheckboxes: PropTypes.bool,
  openedOptionId: PropTypes.string.isRequired,
  onOpeningMainOption: PropTypes.func.isRequired
};

export default Accordion;
